import styled from "styled-components";
import { BorderColors } from "@abel-technologies-as/components";

const ModalBody = styled.div`
	margin-top: 10px;
`;

const Divider = styled.div`
	height: 1px;
	background-color: ${BorderColors.Secondary};
	margin: 0;
`;

export { ModalBody, Divider };
